import React, { Suspense } from 'react'
import { render } from "react-dom";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import {
  BrowserRouter,
  Routes,
  Route
} from "react-router-dom";

import "react-select-search/style.css";
import 'react-toastify/dist/ReactToastify.css';
import './assets/styles/styles.scss'
// Pages are lazy-loaded, but these stylesheets hold classes used across the
// app (ag-grid base styles, .selectMenu, .dialog, ...). Loading them here keeps
// every page styled the same no matter which route is opened first.
import 'react-datepicker/dist/react-datepicker.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import './assets/styles/modal.scss';
import './assets/styles/inner/table.scss';
import './assets/styles/login.scss';
import './assets/styles/controlpanel.scss';
import './assets/styles/caterer-invoicing.scss';
import './assets/styles/card-blacklist.scss';
import './assets/styles/audit-logs.scss';
import './pages/operations/inner-components/menu.scss';
import './pages/alertsWarnings/alertsWarnings.scss';
import './pages/eventNotifications/NotificationDetailModal.scss';
import { ToastContainer } from "react-toastify";

// import App from "./App";
import { NotFoundError } from "./components/Error_Page/NotFoundError";
import { Loading } from "./common/Loading";
import { lazyWithRetry } from "./utils/lazyWithRetry";
import { SomethingWentWrongError } from "./components/Error_Page/SomethingWentWrongError";
import { ThemeProvider } from './contexts/themeContext';
import { initSentry, setSentryUser, Sentry } from './utils/sentry';
import UserSession from './utils/userSessionClass';

// Login and the app shell are separate chunks, so the login page doesn't
// download the whole application.
const Login = lazyWithRetry(() => import("./pages/login/Login"));
const HomePage = lazyWithRetry(() => import("./pages/home"), "HomePage");

initSentry();

// Reattach the Sentry user context after a page reload - setSentryUser() is
// otherwise only called from the Login flow, and Sentry keeps no state of
// its own across reloads.
const existingSession = new UserSession().getSessionValues();
if (existingSession.user_id) {
  setSentryUser({
    userId: existingSession.user_id,
    userName: existingSession.username,
    employeeName: existingSession.employeeName,
  });
}

const rootElement = document.getElementById("root");

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .use(HttpApi)
  .init({
    // lng: document.querySelector('html').lang, // if you're using a language detector, do not define the lng option
    supportedLngs: ['en', 'ar', 'fr','sp'],
    fallbackLng: "en",
    detection: {
  order: ['localStorage', 'cookie', 'navigator'],
  caches: ['localStorage'],
  lookupLocalStorage: 'language' 
},
    backend: {
      loadPath: '/assets/locales/{{lng}}/translation.json',
    },
    react: {
      useSuspense: false
    }
  });



render(
    <Sentry.ErrorBoundary fallback={<SomethingWentWrongError />}>
      <ThemeProvider>
        <BrowserRouter>
          <Suspense fallback={<Loading />}>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/*" element={<HomePage />} />
              <Route path="*" element={<NotFoundError />} />
            </Routes>
          </Suspense>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            toastStyle={{ fontSize: '1rem' }}
            style={{ zIndex: 999999 }}
          />
        </BrowserRouter>
      </ThemeProvider>
    </Sentry.ErrorBoundary>
  ,
  rootElement
);

const resizeObserverErr = /ResizeObserver loop completed/;

window.addEventListener('error', (e) => {
  if (resizeObserverErr.test(e.message)) {
    e.stopImmediatePropagation();
  }
});